export const TRADING_PARTNERS = [
  { code: "RJ-CAPE", name: "Ron Jon Surf Shop - Cape Canaveral" },
  { code: "RJ-ORANG", name: "Ron Jon Surf Shop - Orange Beach" },
  { code: "RJ-OCEAN", name: "Ron Jon Surf Shop - Ocean City" },
  { code: "RJ-MYRT", name: "Ron Jon Surf Shop - Myrtle Beach" },
  { code: "RJ-PCB", name: "Ron Jon Surf Shop - Panama City Beach" },
  { code: "RJ-FtM", name: "Ron Jon Surf Shop - Ft Myers" },
  { code: "RJ-NMYRT", name: "Ron Jon Surf Shop - North Myrtle Beach" },
  { code: "RJ-FESTBAY", name: "Ron Jon Surf Shop - Festival Bay" },
  { code: "RJ-SUN", name: "Ron Jon Surf Shop- Sunrise" },
  { code: "WHOLE", name: "Waboba Wholesale" },
  { code: "WHOLE-SC", name: "Waboba Wholesale Ship Complete" },
  { code: "RJ-NJ", name: "Ron Jon Surf Shop - New Jersey" },
  { code: "TROP", name: "Tropical Waves" },
  { code: "BCHUNLMT", name: "Beach Unlimited" },
  { code: "MARCO", name: "Marco Destin" },
  { code: "ALVIN", name: "Alvin's Island" },
  { code: "USVIN", name: "US Vintage" },
  { code: "BELK", name: "Belk Stores" },
  { code: "SCHEEL", name: "Scheels" },
  { code: "PACFLY", name: "Pacific Flvwav Wholesale" },
  { code: "RCI", name: "Retail Concepts Inc" },
  { code: "MEIJER", name: "Mailer" },
  { code: "FLEFT", name: "Fleet Farm" },
  { code: "HEB", name: "HEB" },
  { code: "DICKS", name: "Dicks Sporting Goods" },
  { code: "CHEWY", name: "Chewy.com" },
  { code: "BBB", name: "Bed Bath & Beyond" },
  { code: "BIG5", name: "Big 5 Sporting Goods" },
  { code: "BASS", name: "Bass Pro Shops" },
  { code: "ACADEMY", name: "Academy Sports" },
  { code: "DEFAULT", name: "DEFAULT" },
];
